// extracted by mini-css-extract-plugin
module.exports = {"title":"Item_title__2dy-8","time":"Item_time__1APBb","image":"Item_image__3LRN1"};